// components/ExportButton.tsx

import { FileSpreadsheet } from "lucide-react";
import type React from "react";
import { exportToExcel } from "../utility/exportExcel";

interface Props {
	data: any[];
	columns?: { key: string; header?: string }[];
	fileName?: string;
	sheetName?: string;
	isLoading?: boolean;
}

const ExportButton: React.FC<Props> = ({
	data,
	columns,
	fileName,
	sheetName,
	isLoading = false,
}) => {
	const handleExport = async () => {
		await exportToExcel(data, { columns, fileName, sheetName });
	};

	return (
		<button
			onClick={handleExport}
			disabled={isLoading || !data.length}
			title="Export to Excel"
			className="btn btn-sm btn-success d-flex align-items-center gap-2"
		>
			<FileSpreadsheet size={20} />
			Export
		</button>
	);
};

export default ExportButton;
